import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconEdgeBottom12 from './IconEdgeBottom12';
import IconEdgeBottom16 from './IconEdgeBottom16';
import IconEdgeBottom20 from './IconEdgeBottom20';
import IconEdgeBottom24 from './IconEdgeBottom24';
import IconEdgeBottom32 from './IconEdgeBottom32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconEdgeBottom = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconEdgeBottom12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconEdgeBottom16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconEdgeBottom20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconEdgeBottom24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconEdgeBottom32 {...props} />}
        </span>
    );
};
IconEdgeBottom.displayName = 'FondueIconEdgeBottom';

export default memo(IconEdgeBottom);
